import { AxiosRequestConfig, AxiosResponse } from "axios";
import { API_PATH } from "../server-data";
import { axiosAuth } from "./interceptor";

export const createTargetService = (
  TargetObject: any
): Promise<AxiosResponse> => {
  //TargetObject.company = company;
  const displayName =
    JSON.parse(localStorage.getItem("user") || "").displayName ||
    JSON.parse(localStorage.getItem("user") || "").email;

  TargetObject.displayName = displayName;

  return axiosAuth.post(API_PATH().apis.target, {
    ...TargetObject,
  });
};

export const updateTargetService = (
  TargetObject: any
): Promise<AxiosResponse> => {
  const displayName =
    JSON.parse(localStorage.getItem("user") || "").displayName ||
    JSON.parse(localStorage.getItem("user") || "").email;
  return axiosAuth.put(API_PATH().apis.target, {
    ...TargetObject,
    displayName,
  });
};

export const getTargetListService = (
  TargetObject: any
): Promise<AxiosResponse> => {
  let config: AxiosRequestConfig = {
    params: {
      //   businessUnit:
      //     localStorage.getItem("currentBusinessUnit") &&
      //     JSON.parse(localStorage.getItem("currentBusinessUnit") || "").id,
    },
  };
  const bunitsStr = localStorage.getItem("bunits");
  if (bunitsStr) {
    config.params.businessUnitIds = bunitsStr;
  }
  config.params.page = (TargetObject.controller.page || 0) + 1;
  config.params.limit = TargetObject.controller.limit;
  config.params.searchText = TargetObject.searchText;
  if (TargetObject?.controller?.sortBy && TargetObject?.controller?.sortOrder) {
    config.params.sortBy = TargetObject?.controller?.sortBy;
    config.params.sortOrder = TargetObject?.controller?.sortOrder;
  }
  return axiosAuth.get(API_PATH().apis.targets, config);
};

//send businessUnit id for it
export const getTargetService = (businessUnit: any): Promise<AxiosResponse> => {
  let config: AxiosRequestConfig = {
    params: {
      businessUnit: businessUnit,
    },
  };
  return axiosAuth.get(API_PATH().apis.target, config);
};

export const discardTargets = (reqMap: any): Promise<AxiosResponse> => {
  return axiosAuth.put(API_PATH().apis.discardtargets, reqMap);
};
